<script lang="ts" setup>
export interface PageHeaderLinksBoxProps {
    heading: string
    showSubtitle?: boolean
    backgroundColor: string
    links: PageHeaderLinksBoxLink[]
}

const props = withDefaults(defineProps<PageHeaderLinksBoxProps>(), {
    showSubtitle: false,
})
</script>
<template>
  <section
    class="page-header-links-box px-4 py-5 p-lg-6 rounded h-100"
    :style="`--page-header-links-box-bg-color: var(--global-color-${props.backgroundColor});`"
  >
    <Tracker :data="{ title: props.heading }">
      <h2 class="delta mb-2 mb-md-6">
        {{ props.heading }}
      </h2>
      <ListBullets class="page-header-links-box-list">
        <li
          v-for="(link, index) in props.links"
          :key="`pgbli-${index}`"
        >
          <VNuxtLink
            class="d-block text-decoration-none fw-bold fs-smaller text-black text-hover-secondary"
            :target="link.isExternal ? '_blank' : '_self'"
            :label="link.title"
            :class="{
              'd-flex align-items-center':
                !props.showSubtitle,
            }"
            :to="link.url"
          >
            {{ link.title }}
            <span
              v-if="props.showSubtitle && link.subtitle"
              class="d-flex align-items-start fs-small fw-normal mt-1"
            >
              {{ link.subtitle }}
              <svg
                class="d-none d-md-block transition ms-2 flex-shrink-0"
                width="6"
                height="16"
                aria-hidden="true"
              >
                <use xlink:href="#angle-right" />
              </svg>
            </span>
            <svg
              v-if="!props.showSubtitle"
              class="d-none d-md-block transition ms-2 flex-shrink-0"
              width="6"
              height="12"
              aria-hidden="true"
            >
              <use xlink:href="#angle-right" />
            </svg>
          </VNuxtLink>
        </li>
      </ListBullets>
    </Tracker>
  </section>
</template>

<style lang="scss">
@import './PageHeaderLinksBox.scss';
</style>
